import { NextRouter } from 'next/router';
import { tracker } from 'src/utils/analytics';

export function setInstoreCartTrackerContextFromQuery(query: NextRouter['query']): void {
  const { checkoutToken, isKiosk, isHub } = query;

  tracker.setContext({
    isKioskOrder: isKiosk === 'true',
    checkoutToken: typeof checkoutToken === 'string' ? checkoutToken : undefined,
    isHubOrder: isHub === 'true',
  });
}
